<p-table 
    [value]="value" 
    [columns]="cols" 
    [lazy]="true" 
    (onLazyLoad)="onLazyLoad.emit($event)"
    [paginator]="true" 
    [rows]="rows" 
    [totalRecords]="totalRecords" 
    [loading]="loading"
    [resizableColumns]="resizableColumns"
    columnResizeMode="expand" 
    [scrollable]="scrollable" 
    [scrollHeight]="scrollHeight"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} of {totalRecords}"
    [rowsPerPageOptions]="rowsPerPageOptions" 
    [tableStyle]="tableStyle"
    [paginatorPosition]="paginatorPosition"
    >

    <!-- Header Template Injected from Parent -->
    <ng-template pTemplate="header" let-columns>
        <ng-container *ngTemplateOutlet="headerTemplate; context: {$implicit: columns}"></ng-container>
    </ng-template>

    <!-- Body Template Injected from Parent -->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <ng-container *ngTemplateOutlet="bodyTemplate; context: {$implicit: rowData, columns: columns}"></ng-container>
    </ng-template>

    
</p-table>